module.exports = __webpack_public_path__ + "img/add-departure-arrange-climbing-table-icon.8eec0800.svg";